import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { RouteDefinition } from "components/router/Routes";

export function useIsChildRouteEnabled() {
    const isRouteEnabled = useIsRouteEnabled();

    const isChildRouteAdvertised = (route: RouteDefinition) => {
        const isEnabled = isRouteEnabled(route);
        return !isEnabled && (route.advertised ?? false);
    };

    const isChildRouteEnabled = (route: RouteDefinition) => isRouteEnabled(route) || isChildRouteAdvertised(route);

    return { isChildRouteEnabled, isChildRouteAdvertised };
}
